<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="glass-strong rounded-xl p-6 w-full max-w-md mx-4">
      <h3 class="text-xl font-bold text-white mb-4">New Booking</h3>
      <form @submit.prevent="handleSubmit">
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-slate-300 mb-1">Equipment</label>
            <input
              v-model="form.equipment"
              type="text"
              required
              placeholder="e.g. Canon C300"
              class="w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-300 mb-1">User</label>
            <input
              v-model="form.user"
              type="text"
              required
              placeholder="e.g. Alex"
              class="w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white"
            />
          </div>
          <div class="grid grid-cols-2 gap-3">
            <div>
              <label class="block text-sm font-medium text-slate-300 mb-1">Start</label>
              <input
                v-model="form.start"
                type="date"
                required
                class="w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white"
              />
            </div>
            <div>
              <label class="block text-sm font-medium text-slate-300 mb-1">End</label>
              <input
                v-model="form.end"
                type="date"
                required
                class="w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white"
              />
            </div>
          </div>
        </div>
        <div class="flex space-x-3 mt-6">
          <button
            type="button"
            class="flex-1 px-4 py-2 bg-slate-800/70 border border-slate-700 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-[--ring]"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button type="submit" class="flex-1 px-4 py-2 rounded-lg btn-primary">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const emit = defineEmits(['close', 'save'])

const form = ref({
  equipment: '',
  user: '',
  start: '',
  end: '',
})

const handleSubmit = () => {
  emit('save', { ...form.value })
}
</script>
